import { Box, Dialog, IconButton, makeStyles, Typography } from '@material-ui/core'
import { Edit } from '@material-ui/icons';
import MROButton from 'components/buttons';
import FileUpload from 'components/form_components/fileUpload';
import GetInfoCard from 'components/GetInfoCard';
import { ICON_COLOUR } from 'lib/constants/style_constants';
import { ToastMessageContext } from 'lib/contexts/message_context';
import { MaintenanceServices } from 'lib/services/api/operaitons/WorkShop/TaskLibrary/Maintenance/maintenance_operation';
import DispatchServices from 'lib/services/api/stores/parts/dispatch';
import { getOrganisationId } from 'lib/utils/common_utils';
import React, { useContext, useEffect, useState } from 'react'
import ScopeDialog from 'views/Compliance/Approvals/Capability/ScopeDialog'



const useStyles = makeStyles((theme) => ({
    bodyText: {
        fontSize: 18,
        // lineHeight: "28px",
        paddingRight: "20px",
        paddingLeft: "5px"
    },
    partCard: {
        borderRadius: "8px",
        padding: "12px 4px",
        "& p": {
            fontSize: "14px",
            padding: "5px",
        },
    },
    actionButtons: {
        paddingTop: "5px",
        paddingBottom: "20px",
        textAlign: "right",
        marginRight: "20px",
        "& button:not(:last-child)": {
            marginRight: "20px",
        },
    },
}));





export default function ManageDispatch(props) {
    const classes = useStyles()
    const { open, handleClose, rowDetails } = props
    const [boolState, setBoolState] = useState(false);
    const [records, setRecords] = useState([]);
    const [loading, setLoading] = useState(true)
    const [files, setFiles] = useState([])
    const [details, setDetails] = useState({})
    const message = useContext(ToastMessageContext)




    const getDispatchDetails = async () => {
        try {
            const param = { dispatch_id: rowDetails.id }
            const response = await DispatchServices.getDispatchDetails(param)

            if (response.success) {
                setDetails(response.data)
                setFiles(response.data.files)

            }

        }
        catch (error) {

        }
    }
    useEffect(() => {
        if (rowDetails !== undefined) {


            getDispatchDetails()
        }

    }, [rowDetails])


    const deleteFileHandler = async (id) => {
        setLoading("file-deleting");
        try {
            const response = await MaintenanceServices.deleteFile(id);

            if (response.success) {
                message.showToastMessage({
                    message: "File deleted successfully",
                    variant: "success",
                });

                getDispatchDetails()
            }
            setLoading(null);
        } catch (error) {
            message.showToastMessage({
                message: "Something went wrong",
                variant: "error",
            });
            setLoading("file-deleting-error");
        }
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        const formData = new FormData(e.target);
        // formData.append("task_id", currentSelection?.id);
        if (records.length > 0) {
            records.forEach((item) => formData.append("dispatch_signed_documents[]", item));

            formData.append("dispatch_id", rowDetails.id);
            formData.append("organisation_id", getOrganisationId());
            setLoading("file_upload")
            DispatchServices.uploadDispatchFiles(formData)
                .then((res) => {
                    message.showToastMessage({
                        message: " File added successfully",
                        variant: "success",
                    });
                    handleClose();;
                })
                .catch((err) => {
                    message.showToastMessage({
                        message: "Something went wrong",
                        variant: "error",
                    });
                })
                .finally(() => {
                    setLoading(null);
                });
        }
        else {
            handleClose();
        }

    };



    return (
        <ScopeDialog
            open={open}
            handleClose={handleClose}
            width="700px"
            notShowButton={true}
        >
            <Box display={"flex"} justifyContent="space-between" mb="15px">
                <Box>
                    <Typography color="primary" className={classes.bodyText}>
                        Dispatch Detail
                    </Typography>

                </Box>

            </Box>


            <Box
                display="flex"
                alignItems="center"
                //   justifyContent={(loading || _.isEmpty(partDetails)) && "center"}
                bgcolor="#F5F5F5"
                className={classes.partCard}
            >
                <Box flexGrow={1}>
                    <div style={{ width: "100%" }}>
                        <GetInfoCard keyName={"DN #"} value={details?.dn_number ?? "-"} />
                        <GetInfoCard keyName={"Raised"} value={details?.raised_at ?? "-"} />
                        <GetInfoCard keyName={"Raised By"} value={details?.raised_by ?? "-"} />
                        <GetInfoCard keyName={"Base"} value={details?.base ?? "-"} />
                        <GetInfoCard keyName={"Weight"} value={details?.weight ?? "-"} />
                        <GetInfoCard keyName={"Dimensions (L/W/H)"} value={details?.dimensions ?? "-"} />
                        <GetInfoCard keyName={"Address"} value={details?.address ?? "-"} />
                        <GetInfoCard keyName={"Carrier / Collected By"} value={details?.carrier ?? "-"} />
                        <GetInfoCard keyName={"Reference / Name"} value={details?.reference ?? "-"} />
                        <GetInfoCard keyName={"Shipping Fee"} value={details?.shipping ?? "-"} />

                    </div>
                </Box>
            </Box>
            <Box display={"flex"} justifyContent="space-between" mb="15px" mt={'5px'}>
                <Box display={"flex"}>
                    <Typography color="primary" className={classes.bodyText}>
                        Dispatch Files
                    </Typography>
                    {!boolState ? <IconButton onClick={() => {
                        setBoolState(true)

                    }}>

                        <Edit htmlColor={ICON_COLOUR} style={{ fontSize: '15px' }} />
                    </IconButton> : " "}
                </Box>

            </Box>
            <form noValidate onSubmit={handleSubmit}>
                <FileUpload
                    isLoading={loading === "uploading"}
                    defaultValue={files !== undefined ? files.map((file) => ({
                        filename: file?.file_name,
                        url: file?.file_path,
                        id: file?.id,
                    })) : ''}
                    setFiles={(files) => {
                        setRecords(files);
                    }}
                    accept={"multiple"}
                    onDelete={boolState === false ? null : deleteFileHandler}
                    showBorderOnNoFiles={true}
                    multiple={true}
                    APIUrl={""}
                    isDeleting={loading === "file-deleting"}
                    uploadButtonView={boolState === false}
                    // name={"certificates[]"}
                    action={"Upload Document"} />


                {boolState === true && (
                    <div className={classes.actionButtons}>
                        <MROButton variant={"contained"}
                            onClick={handleClose}>
                            Cancel
                        </MROButton>
                        <MROButton
                            loading={loading === "file_upload"}
                            variant={"contained"}
                            color={"primary"}
                            type={"submit"}
                        >
                            Complete
                        </MROButton>
                    </div>


                )}
            </form>
        </ScopeDialog>
    )
}
